<template>
    <div v-loading="loading">
        <div class="grid grid-cols-2 gap-2">
            <div class="min-w-60">
                <label>
                    Thời gian chờ tối đa cho phép
                </label>
                <hts-form-input
                    v-model="settingData.maxWaitingTime"
                    :min="0"
                    placeholder=""
                    type="number">
                    <template #suffix>
                        giờ
                    </template>
                </hts-form-input>
            </div>
            <div class="min-w-60">
                <label>
                    Chi phí chờ (số tiền/giờ):
                </label>
                <hts-form-input
                    v-model="settingData.waitingPrice"
                    :min="0"
                    placeholder=""
                    type="number">
                    <template #suffix>
                        /giờ
                    </template>
                </hts-form-input>
            </div>
        </div>
        <hts-divider />
        <h4>
            Cài đặt thời gian thực hiện điều phối chính thức:
        </h4>
        <div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label>
                        Điều phối lần 1 vào:
                    </label>
                    <div class="flex items-center gap-4 mb-2">
                        <hts-form-select
                            v-model="settingData.startRange.hour"
                            :items="hours"
                            key-id="value"
                            key-label="label"
                            name="startHour"
                            prop="startHour"
                            :clearable="false"
                            @change="onChangeTime('start', 'startRange', $event)" />
                        <span>
                            :
                        </span>
                        <hts-form-select
                            v-model="settingData.startRange.min"
                            :items="minutes"
                            key-id="value"
                            key-label="label"
                            name="startMinute"
                            prop="startMinute"
                            :clearable="false"
                            @change="onChangeTime('start', 'startRange', $event)" />
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label>
                        Cho các chặng khởi hành sau:
                    </label>
                    <hts-form-input
                        v-model="settingData.startRange1"
                        :min="0"
                        :max="settingData.startRange2"
                        placeholder=""
                        type="number"
                        class="mb-1">
                        <template #suffix>
                            giờ
                        </template>
                    </hts-form-input>
                </div>
                <div>
                    <label>
                        đến
                    </label>
                    <hts-form-input
                        v-model="settingData.startRange2"
                        :min="settingData.startRange1"
                        :max="23"
                        placeholder=""
                        type="number"
                        class="mb-1">
                        <template #suffix>
                            giờ
                        </template>
                    </hts-form-input>
                    <!--
                      <span class="font-medium">
                      {{ $formatters.datetime(today.hour(settingData.start + settingData.startRange2).valueOf()) }}
                      </span>
                    -->
                </div>
            </div>
        </div>
        <br >
        <div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label>
                        Điều phối lần 2 vào:
                    </label>
                    <div class="flex items-center gap-4 mb-2">
                        <hts-form-select
                            v-model="settingData.endRange.hour"
                            :items="hours"
                            key-id="value"
                            key-label="label"
                            name="startHour"
                            prop="startHour"
                            :clearable="false"
                            @change="onChangeTime('end', 'endRange', $event)" />
                        <span>
                            :
                        </span>
                        <hts-form-select
                            v-model="settingData.endRange.min"
                            :items="minutes"
                            key-id="value"
                            key-label="label"
                            name="startMinute"
                            prop="startMinute"
                            :clearable="false"
                            @change="onChangeTime('end', 'endRange', $event)" />
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label>
                        Cho các chặng khởi hành sau:
                    </label>
                    <hts-form-input
                        v-model="settingData.endRange1"
                        disabled
                        placeholder=""
                        type="number"
                        class="mb-1">
                        <template #suffix>
                            giờ
                        </template>
                    </hts-form-input>
                </div>
                <div>
                    <label>
                        đến
                    </label>
                    <hts-form-input
                        v-model="settingData.endRange2"
                        disabled
                        placeholder=""
                        type="number">
                        <template #suffix>
                            giờ
                        </template>
                    </hts-form-input>
                    <!--
                      <span class="font-medium">
                      {{ $formatters.datetime(today.hour(settingData.end + settingData.endRange2).valueOf()) }}
                      </span>
                    -->
                </div>
            </div>
        </div>
        <div class="flex justify-between items-center">
            <hts-form-button
                class="mt-4"
                icon-name="hi-clipboard-document-check-icon"
                icon-position="right"
                color="primary"
                :loading="updating"
                @click="updateSettings">
                {{ $t('labels.save') }}
            </hts-form-button>
            <hts-form-button
                class="mt-4"
                :loading="reseting"
                @click="resetAll">
                {{ $t('labels.reset') }}
            </hts-form-button>
        </div>
    </div>
</template>
<script lang="ts" setup>
const { $dayjs } = useNuxtApp()
/** Define & variables */
const { system } = $store()
const today = $dayjs().minute(0).second(0)
const loading = ref(false)
const updating = ref(false)
const reseting = ref(false)
const resetAll = () => {
  reseting.value = true
  $api($urlPartner.journey.schedule.setting.reset).then(() => {
    reseting.value = false
  })
}
const settingData = reactive<any>({
  maxWaitingTime: 4,
  start: 9,
  startRange1: 7,
  startRange2: 17,
  end: 16,
  endRange1: 10,
  endRange2: 24,
  waitingPrice: 0,
  startRange: {
    hour: '0',
    min: '0'
  },
  endRange: {
    hour: '0',
    min: '0'
  }
})

/** Watching */
watch(
  () => settingData.start,
  (val) => {
    settingData.endRange1 = (settingData.start + settingData.startRange2 - settingData.end).toFixed(2)
    settingData.endRange2 = (settingData.start + settingData.startRange1 + (24 - settingData.end)).toFixed(2)
  }
)
watch(
  () => settingData.end,
  (val) => {
    settingData.endRange1 = (settingData.start + settingData.startRange2 - settingData.end).toFixed(2)
    settingData.endRange2 = (settingData.start + settingData.startRange1 + (24 - settingData.end)).toFixed(2)
  }
)
watch(
  () => settingData.startRange1,
  (val) => {
    settingData.endRange2 = (settingData.start + settingData.startRange1 + (24 - settingData.end)).toFixed(2)
  }
)
watch(
  () => settingData.startRange2,
  (val) => {
    settingData.endRange1 = (settingData.start + settingData.startRange2 - settingData.end).toFixed(2)
  }
)

/** Methods */
const getSettings = () => {
  loading.value = true
  $api($urlPartner.journey.schedule.setting.get).then(({ data }) => {
    const temp = (data?.value || {}).data || {}
    Object.assign(settingData, temp)
    Object.assign(settingData.startRange, setTime(settingData.start))
    Object.assign(settingData.endRange, setTime(settingData.end))
    loading.value = false
  })
}

const updateSettings = () => {
  updating.value = true
  $api($urlPartner.journey.schedule.setting.update, { body: settingData })
    .then(({ data }) => {
      const temp = (data?.value || {}).data || {}
      Object.assign(settingData, temp)
      system.setScheduleSettings(settingData)
      updating.value = false
      process.client && $toast().success($t('notifications.updateSuccess'))
    })
    .catch(() => {
      updating.value = false
    })
}

/** Utils */
const hours = [
  { value: '0', label: '00' },
  { value: '1', label: '01' },
  { value: '2', label: '02' },
  { value: '3', label: '03' },
  { value: '4', label: '04' },
  { value: '5', label: '05' },
  { value: '6', label: '06' },
  { value: '7', label: '07' },
  { value: '8', label: '08' },
  { value: '9', label: '09' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' }
]
const minutes = [
  { value: '0', label: '00' },
  { value: '1', label: '01' },
  { value: '2', label: '02' },
  { value: '3', label: '03' },
  { value: '4', label: '04' },
  { value: '5', label: '05' },
  { value: '6', label: '06' },
  { value: '7', label: '07' },
  { value: '8', label: '08' },
  { value: '9', label: '09' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' },
  { value: '24', label: '24' },
  { value: '25', label: '25' },
  { value: '26', label: '26' },
  { value: '27', label: '27' },
  { value: '28', label: '28' },
  { value: '29', label: '29' },
  { value: '30', label: '30' },
  { value: '31', label: '31' },
  { value: '32', label: '32' },
  { value: '33', label: '33' },
  { value: '34', label: '34' },
  { value: '35', label: '35' },
  { value: '36', label: '36' },
  { value: '37', label: '37' },
  { value: '38', label: '38' },
  { value: '39', label: '39' },
  { value: '40', label: '40' },
  { value: '41', label: '41' },
  { value: '42', label: '42' },
  { value: '43', label: '43' },
  { value: '44', label: '44' },
  { value: '45', label: '45' },
  { value: '46', label: '46' },
  { value: '47', label: '47' },
  { value: '48', label: '48' },
  { value: '49', label: '49' },
  { value: '50', label: '50' },
  { value: '51', label: '51' },
  { value: '52', label: '52' },
  { value: '53', label: '53' },
  { value: '54', label: '54' },
  { value: '55', label: '55' },
  { value: '56', label: '56' },
  { value: '57', label: '57' },
  { value: '58', label: '58' },
  { value: '59', label: '59' }
]

const onChangeTime = (key: string, key2: string, val: any) => {
  if (!settingData[key] || !settingData[key2]) {
    return
  }
  const { hour, min } = settingData[key2]
  const tmpHour = parseInt(hour, 10)
  const tmpMin = parseInt(min, 10)
  const tmpMinF = parseFloat((tmpMin / 60).toFixed(2))
  settingData[key] = tmpHour + tmpMinF
}
const setTime = (val: number) => {
  const hour = parseInt(val.toString()).toString()
  const min = parseInt(Math.round((val - Math.floor(val)) * 60).toString(), 10).toString()
  return { hour, min }
}
const show = () => {
  getSettings()
}
onMounted(() => {
  show()
})
</script>
